import HttpService from '@/services/http/http.service';

export default class UserService {
	constructor() {
		this.http = new HttpService();
	}

	changePassword(data) {
		return this.http.patch('user/password', data);
	}

	get() {
		return this.http.get('user');
	}
}
